

import { IRequestConfig } from "angular";
import { appModule } from "../../app/app-module";
import { utilsModule } from "../utils-module";

utilsModule.factory('ownerIdHttpInterceptor', ['localStorageService',function (localStorageService:any) {

    let exceptionHosts:string[] = [
        'apps.widenet.com.br'
    ];

    let shouldIntercept = function(url:string){
        for (var i in exceptionHosts){
            var host = exceptionHosts[i];
            if (url.indexOf(host) > -1){
                return false;
            }
        }
        return true;
    }

    return {
        request: function(config:IRequestConfig) {
            let skipOwnerId = config.params && config.params.skipOwnerId == true;
            if (shouldIntercept(config.url) && !skipOwnerId){
                //console.log(`interceptador incorporando ownerId ${localStorageService.get('ownerId')}`)
                config.headers['ownerId'] = localStorageService.get('ownerId');
                if (config.params && config.params.skipIncludeInWhereFilter == true) {
                    config.headers['skipIncludeInWhereFilter'] = "true"
                }
            }
            return config;
        }
    }
}]);